import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '@app/shared/services/utils/util.service';

@Component({
  selector: 'cm-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
  @Input() public visible!: any;
  @Input() public target: any;
  @Input() public showCloseIcon: boolean;
  @Input() public showBackdrop: boolean;
  @Input() public type: 'basic' | 'quickview' | 'closable' | 'tooltip' | 'filter';
  @Input() public hideArrow: boolean;
  @Input() public width: string;
  @Input() public padding: string;
  @Input() public fieldType: string;

  @Input() public set position(position: string | any) {
    this._firstPosition = position;
    this.popoverPosition = position;
  }

  @Output() public hiding: EventEmitter<void>;

  public isMobile: boolean;
  public popoverPosition: string | any;
  public extraClass: string;

  private _firstPosition: string | any;
  private _isFirstLoad: boolean;

  constructor() {
    this._isFirstLoad = true;
    this.showBackdrop = true;
    this.position = {
      my: 'top center',
      at: 'bottom center',
      collision: 'fit flip',
    };
    this.hiding = new EventEmitter<void>();
  }

  @HostListener('window:resize', [])
  public onResize(): void {
    this.isMobile = UtilService.isMobileAndTabletSize();
    this.changePositionByType();
  }

  ngOnInit() {
    this.onResize();
  }

  public onContentChange(element: MutationRecord): void {
    if (this.isMobile) {
      if (!this._isFirstLoad) {
        this.changePositionByType();

        if (element && element[0]?.target?.click && this.showBackdrop) {
          element[0].target.click(); // This click is to change the position after loading
        }
      } else {
        this._isFirstLoad = false;
      }
    }
  }

  public closePopOver(event) {
    event.preventDefault();
    this.hiding.emit();
  }

  public relocateFilter(): void {
    if (this.fieldType !== 'form') {
      return;
    }

    const popoverRef = '.dx-popover-wrapper.cm-popover-filter > div';
    const popoverElement = document?.querySelector(`${popoverRef}`) as HTMLElement;

    if (popoverElement) {
      popoverElement.style.visibility = 'hidden';

      setTimeout(() => {
        let [translateX, translateY] = popoverElement.style.transform
          .split(',')
          .map((t) => parseInt(t.replace(/^\D+/g, '')));

        if (translateX > window.innerWidth / 2) {
          this.position = {
            my: 'top right',
            at: 'bottom right',
            collision: 'fit flip',
          };
        }

        popoverElement.style.visibility = 'visible';

        setTimeout(() => {
          [translateX, translateY] = popoverElement.style.transform
            .split(',')
            .map((t) => parseInt(t.replace(/^\D+/g, '')));

          popoverElement.style.transform = `translate(${translateX}px, ${translateY - 10}px)`;
          popoverElement.style.visibility = 'visible';
        }, 0);
      }, 0);
    }
  }

  public changePositionByType(): void {
    this.extraClass = '';
    const defaultPosition = {
      my: 'top center',
      at: 'bottom left',
      collision: 'fit flip',
    };
    const centered = { my: 'center', at: 'center', of: window };

    switch (this.type) {
      case 'basic':
        this.showCloseIcon = false;
        this.popoverPosition = this._firstPosition ? this._firstPosition : defaultPosition;
        break;

      case 'quickview':
        this.extraClass = 'cm-quickview-popover';
        this.popoverPosition = this.isMobile ? centered : this._firstPosition;
        this.showCloseIcon = true;
        break;

      case 'closable':
        this.showCloseIcon = true;
        this.popoverPosition = this._firstPosition ? this._firstPosition : defaultPosition;
        break;

      case 'tooltip':
        this.extraClass = 'cm-popover-tooltip';
        break;

      case 'filter':
        this.extraClass = 'cm-popover-filter';
        break;

      default:
        this.popoverPosition = this._firstPosition ? this._firstPosition : defaultPosition;
        break;
    }

    this.extraClass += this.hideArrow ? ' cm-popover-hide-arrow' : '';
    this.extraClass = this.extraClass.trim();
  }
}
